import type { DefaultTheme } from 'styled-components';
import { lightColors, mapLightTheme, talosLightButtons } from './LightTheme';

export const LightTalosMobileTheme: DefaultTheme = mapLightTheme(lightColors, {
  name: 'LightTalosMobile',
  ...talosLightButtons,

  fontSizeInput: 1,

  fontSizeDefault: 1,
  fontSizeSmall: 0.875,
  fontSizeTiny: 0.75,
});
